import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import moment from 'moment'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import TopayStatenentReportTable from './TopayStatenentReportTable'
import DropDownOA from '../../../common/dropDownOA'
import { connect } from 'react-redux'
import { getOwnChildBranches, getToPayStatementReportData } from '../../../../store/reports/reports_action'
import { getCityList } from '../../../../store/common/common_action'
import { isEmpty } from '../../../common/helper'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest } from '../../../common/api'
import { urls, xlCol, xlColq } from '../../../common/constants'
const TopayStatenentReport = (props) => {
  const { data: { common, reports }, getToPayStatementReportData, getOwnChildBranches, getCityList } = props
  const { loginData, cityList,companySettings } = common
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const { toPayStatementReportData, ownChildBranches } = reports
  const reportName = 'To-Pay Statement'
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [showReport, setShowReport] = useState(false)
  const [tableData, setTableData] = useState([])
  const [reportData, setReportData] = useState([]);
  const [selBranch, setSelBranch] = useState([])
  const [sourceCityData, setSourceCityData] = useState([])
  const [sourceCity, setSourceCity] = useState([])
  const [sourceBranchData, setSourceBranchData] = useState(ownChildBranches)
  const [sourceBranch, setSourceBranch] = useState([])
  const setAlert = useSetAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
   const filterHeaderData = [
          { header: 'From Data', exportHead: 'From Data', field: 'fromDate', xlCol: xlCol, minWidth: "80px", align: "left" },
          { header: 'To Date', exportHead: 'To Date', field: 'toDate', xlCol: xlCol, minWidth: "100px", align: "left" },
          { header: 'City Name', exportHead: 'City Name', field: 'sourceBranch', xlCol: xlCol, minWidth: "80px", align: "left" },
          { header: 'Branch Name', exportHead: 'Branch Name', field: 'sourceCity', xlCol: xlCol, minWidth: "100px", align: "left" },
        ]
        let columnHeader = [
                { header: 'Challan\nNumber', exportHead: 'Challan\nNo.', field: 'CHALLANNO', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Receiver\nName', exportHead: 'Receiver\nName', field: 'RECEIVERNAME', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'From\nStation', exportHead: 'From\nStation', field: 'FROMSTATION', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Booking\nDate', exportHead: 'Booking\nDate', field: 'INCOMINGDATE', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'WayBill\nNumber', exportHead: 'WayBill\nNo.', field: 'WAYBILLNO', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Number\nof Parcel', exportHead: 'NOP', field: 'NOPS', xlCol: xlColq, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Opening\nBalence', exportHead: 'Opening\nBalence', field: 'OPENINGBAL', xlCol: xlColq, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'ToPay\nAmount', exportHead: 'ToPay\nAMT', field: 'TODAYAMT', xlCol: xlColq, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Receive\nAmount', exportHead: 'Receive\nAMT', field: 'RECEIVEAMT', xlCol: xlColq, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Receipt\nNumber', exportHead: 'Receipt\nNo.', field: 'RECEIPTNO', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Due\nAmount', exportHead: 'Due\nAMT', field: 'DUEAMT', xlCol: xlColq, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Delivery\nDate', exportHead: 'Delivery\nDate', field: 'DeliveryDate', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
            ]
            let columnHeaderUpdated = columnHeader.map((col) => {
                if (UseToPayAsCOD === 1) {
                    if (col.field === 'TODAYAMT') {
                        return {
                            ...col,
                            headerName: 'COD\nAMT',
                            exportHead: 'COD\nAMT',
                        };
                    }
                }
                return col;
            });
  useEffect(() => {
    if (cityList.length > 0) {
      const cityListWithAll = [{ CityID: 0, CityName: 'All' }, ...cityList];
      setSourceCityData(cityListWithAll)
      setSourceCity({ CityID: loginData?.intBranchCityID, CityName: loginData?.strCityName });  // Update the state with the new city list
    }

    if (ownChildBranches?.length > 0) {
      const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...ownChildBranches];
      const filteredBranchList = branchListWithAll.filter(branch =>
        branch.CityID === (loginData?.intBranchCityID)
      );
      setSourceBranchData(filteredBranchList)
      //  setSourceBranchData(branchListWithAll);  // Update the state with the new branch list
      setSourceBranch({ BranchID: loginData?.intBranchID, BranchName: loginData?.strBranchName })
    }
  }, [cityList, ownChildBranches]);
  useEffect(() => {
    if (!isEmpty(loginData)) {
      getCityList(loginData)
      const branchData = {
        intUserID: 0,
        intCompanyID: loginData?.intCompanyID,
        intIsActive: 1,
      }
      getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
    }
  }, [loginData])
  useEffect(() => {
    if (toPayStatementReportData.length > 0) {
      const data = toPayStatementReportData?.map((item) => ({ ...item }))
      setTableData(data)
      setReportData(data)
    } else {
      setTableData([])
      setReportData([])
    }

  }, [toPayStatementReportData])
  // const generateReport = () => {
  //   setShowReport(true)
  //   const obj = {
  //     intCompanyID: loginData.intCompanyID,
  //     intBranchID: sourceBranch?.BranchID,
  //     FromDate: moment(fromDate).format('YYYY-MM-DD'),
  //     ToDate: moment(toDate).format('YYYY-MM-DD'),
  //     intUserID: loginData.intUserID,
  //     AllowViewAllReport: 1,
  //   }
  //   getToPayStatementReportData(obj)
  // }

 const filterData = {
        fromDate: moment(fromDate).format('DD-MMM-YY'),
        toDate: moment(toDate).format('DD-MMM-YY'),
        sourceBranch: sourceBranch?.BranchName,
        sourceCity: sourceCity?.CityName,
        dataType: 'entry',
    }
    const generateReport = () => {
        setLoader(true)
        const obj = {
          intCompanyID: loginData.intCompanyID,
          intBranchID: sourceBranch?.BranchID,
          FromDate: moment(fromDate).format('YYYY-MM-DD'),
          ToDate: moment(toDate).format('YYYY-MM-DD'),
          intUserID: loginData.intUserID,
          AllowViewAllReport: 1,
        }
        GetRequest(urls.getToPayStatementReport, obj)
            .then((res) => {
                if (res.status !== 'Success') {
                    throw new Error(res?.ErrMessage || 'Request Failed')
                }
                if (!Array.isArray(res?.Data?.table) || res?.Data?.table.length === 0) {
                    throw new Error('No Data Found')
                }
                const updatedData = res?.Data?.table.map((item, index) => ({
                    ...item,
                    dataType: 'entry',
                   
                }))
                const reportPayload = {
                    reportName,
                    criteriaHeaders: filterHeaderData,
                    criteriaData: [filterData],
                    tableData: updatedData,
                    mainHeader: columnHeaderUpdated,
                    isShowManageColumn: false,
                    manageColumnID: '',
                    hideHeader: false,
                }
                const rid = Date.now().toString()
                if (!window.generatedReports) {
                    window.generatedReports = {}
                }
                window.generatedReports[rid] = reportPayload
                window.open(`/view-report?rid=${rid}`, '_blank')
            })
            .catch((err) => {
                setAlert({ show: true, msg: err.message, nextId: '' })
            })
            .finally(() => setLoader(false))
    }

  const selectedSourceCity = (obj) => {
    setShowReport(false)
    setSourceCity(obj)
    if (obj?.CityID === 0) {
      const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...ownChildBranches];
      setSourceBranchData(branchListWithAll);
      setSourceBranch(branchListWithAll[0])
    } else {
      const filteredBranches = ownChildBranches?.filter((val) => val.CityID === obj?.CityID);
      const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...filteredBranches];
      setSourceBranchData(branchListWithAll);
      setSourceBranch(branchListWithAll[0])

    }
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start' }}>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={`From Booking Date`}
              name={'from_date'}
              value={fromDate}
              id={'fromDate'}
              dateChange={(date) => {
                setFromDate(date)
                // focusElemnt('toDate')
              }}
              width="300px"
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Booking Date'}
              name={'to_date'}
              value={toDate}
              id={'toDate'}
              dateChange={(date) => {
                setToDate(date)
                // focusElemnt('goButtonDate')
              }}
              width="300px"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={`City Name`}
              id={'cityID'}
              data={sourceCityData || []}
              defaultvalue={sourceCity?.CityName || ''}
              dataKey={`CityName`}
              idKey={`CityID`}
              onSelect={(obj) => { selectedSourceCity(obj) }}
              width="100%"
              nextId={'selectedBranch'}
              prevId={'goButtonDate'}
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id={'selectedBranch'}
              label={'Branch Name'}
              // data={roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1 && roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 0 ? ownChildBranches.filter((val) => val.SourceBranchID == loginData?.intBranchCityID) : ownChildBranches || []}
              data={sourceBranchData || []}
              searchPlaceholder={`Search By Branch`}
              defaultvalue={sourceBranch?.BranchName || ''}
              dataKey={`BranchName`}
              idKey={`BranchID`}
              onSelect={(val) => { setSourceBranch(val) }}
              onReset={() => setSourceBranch('')}
              nextId={'generateButton'}
              prevId={'paymentType'}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}
          // onKeyDown={(e) => { navigation3(e, showReport ? "ExpToExlbtn" : 'fromDate', 'selectedBranch', () => generateReport()) }}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={false}
              id1={'generateButton'}
              onClick1={generateReport}
            // onClick2={handleClick2}
            />
          </Item>
        </Box>
      </Item>
      {
        showReport ? <TopayStatenentReportTable UseToPayAsCOD={UseToPayAsCOD} tableData={tableData} setTableData={setTableData} reportData={reportData} loginData={loginData} sourceCity={sourceCity} sourceBranch={sourceBranch} fromDate={fromDate} toDate={toDate}/> : null
      }
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getToPayStatementReportData, getCityList, getOwnChildBranches }
export default connect(mapStateToProps, mapDispatchToProps)(TopayStatenentReport)
